import mistea01 from '@gpt/MISTEA/横版_20260812/01-山雾视觉母版-1280x720.webp';
import mistea02 from '@gpt/MISTEA/横版_20260812/02-白桃乌龙广告-1280x720.webp';
import mistea03 from '@gpt/MISTEA/横版_20260812/03-风味信息图-1280x720.webp';
import mistea04 from '@gpt/MISTEA/横版_20260812/04-品牌触点-1280x720.webp';
import mistea05 from '@gpt/MISTEA/横版_20260812/05-城市Campaign-1280x720.webp';
import mistea06 from '@gpt/MISTEA/横版_20260812/06-广告分镜-1280x720.webp';
import robot01 from '@gpt/扫地机器人系列_第二排_20260812/01_客厅主视觉-1280x720.webp';
import robot02 from '@gpt/扫地机器人系列_第二排_20260812/02_现代厨房-1280x720.webp';
import robot03 from '@gpt/扫地机器人系列_第二排_20260812/03_地毯清洁-1280x720.webp';
import robot04 from '@gpt/扫地机器人系列_第二排_20260812/04_夜间静音-1280x720.webp';
import robot05 from '@gpt/扫地机器人系列_第二排_20260812/05_基站归航-1280x720.webp';
import robot06 from '@gpt/扫地机器人系列_第二排_20260812/06_产品细节-1280x720.webp';
import human01 from '@gpt/真人女性套图_第三排_20260812/01_CCD卧室回眸-1280x720.webp';
import human02 from '@gpt/真人女性套图_第三排_20260812/02_咖啡馆自然笑-1280x720.webp';
import human03 from '@gpt/真人女性套图_第三排_20260812/03_城市街拍行走-1280x720.webp';
import human04 from '@gpt/真人女性套图_第三排_20260812/04_海边风衣侧望-1280x720.webp';
import human05 from '@gpt/真人女性套图_第三排_20260812/05_书店挑书-1280x720.webp';
import human06 from '@gpt/真人女性套图_第三排_20260812/06_雨夜伞下大笑-1280x720.webp';
import videoStoryboard from '@core/AI视频自动化/00_五镜头总览.png';
import videoReview from '@core/AI视频自动化/AI科普短视频_12帧审片图.jpg';
import videoFrame02 from '@core/AI视频自动化/02_记忆线_被拉动.png';
import videoFrame03 from '@core/AI视频自动化/03_尾巴耳朵_稳定信号.png';
import videoFrame04 from '@core/AI视频自动化/04_安全感灯盒_点亮.png';
import videoFrame05 from '@core/AI视频自动化/05_安心日常_完成.png';
import motionPreview from '@core/AI视频自动化/MSN_INFJ_作品集分镜_动效预览帧.png';
import libraryAtlas from '@core/AI学习库/project-atlas-hero.png';
import productVideoFrame from '@core/中小项目候选/商品视频代表帧.png';
import pptOverview from '@core/中小项目候选/PPT工作台总览.png';
import productDetailHero from '@core/中小项目候选/AI商品详情页主图.png';
import vectorInput from '@core/中小项目候选/矢量化输入样例.png';
import aiProjectCollaborationCover from '@core/AI卡片封面_20260805/02_AI项目协作工作台_选定稿.png';
import xiaoheiVideoWorkbenchCover from '@core/AI卡片封面_20260805/03_小黑AI视频工作台_选定稿.png';
import watermarkRemovalWorkbenchCover from '@core/AI卡片封面_20260805/04_智能视频去水印工作台_选定稿.png';
import { aiWorks, formatMediaDuration, gradingWorks, shootingWorks } from './portfolioMedia';

export type Variant = 'professional' | 'creator' | 'workflow';

export const variantMeta: Record<Variant, {
  label: string;
  code: string;
  eyebrow: string;
  title: string;
  subtitle: string;
  statement: string;
}> = {
  professional: {
    label: 'Professional Signal',
    code: 'A',
    eyebrow: 'AI AUTOMATION · AIGC · CONTENT OPS',
    title: 'AI SYSTEMS,\nBUILT TO DELIVER.',
    subtitle: '把 AI 自动化、内容生产与工作流整合为可验证的交付能力。',
    statement: '面向招聘者：先看到岗位价值，再进入项目证据。',
  },
  creator: {
    label: 'Creator System',
    code: 'B',
    eyebrow: 'IDEAS · IMAGES · MOTION · SYSTEMS',
    title: 'MAKE IDEAS\nMOVE FURTHER.',
    subtitle: '让创意不止停在灵感，用 AI 把它推进到画面、视频与可复用流程。',
    statement: '面向创作现场：强调人、判断与持续生产。',
  },
  workflow: {
    label: 'Technical Workflow',
    code: 'C',
    eyebrow: 'INPUT / ORCHESTRATE / GENERATE / VERIFY',
    title: 'FROM PROMPT\nTO PIPELINE.',
    subtitle: '把模型、工具与人工校验接成稳定的 AI 内容工作流。',
    statement: '面向技术协作：展示流程逻辑，同时保持内容岗位可读性。',
  },
};

export const personalityAiVideoUrl = '/media/personality-and-ai.mp4';
export const personalityAiPosterUrl = '/media/personality-and-ai-poster.jpg';
export const watermarkRemovalVideoUrl = '/media/msn-watermark-removal.mp4';

export const aiImageWorks = [
  {
    number: '01',
    slug: 'ai-video-automation',
    name: 'ComfyUI + MiniMax H3 视频生成工作流',
    tag: 'AI PROJECT / VIDEO GENERATION',
    description: '在 ComfyUI 中接入 MiniMax H3：输入提示词即可生成视频，也可添加图片、首尾帧、视频与音频参考，控制人物动作、镜头和视觉风格，输出连贯、细节丰富的动态画面。',
    metrics: ['提示词生成', '多模态参考', '高质量动态'],
    images: ['/assets/core-projects/comfyui-minimax-h3-recording-loop.webp'],
  },
  {
    number: '02',
    slug: 'ai-3d-kinetic-workflow',
    name: 'Hunyuan3D + WebGL 机械资产生成与交互工作流',
    tag: 'AI PROJECT / 3D GENERATION & WEBGL',
    description: '结合混元 3D 多模态建模管线与 Three.js 实时渲染：从多角度概念图生成机械资产，经分件拓扑优化、PBR 物理材质与中心旋转轴绑定，实现高保真 3D 动态交互呈现。',
    metrics: ['AI 三维资产生成', '结构拓扑与分件', 'WebGL 实时光影交互'],
    images: ['/assets/core-projects/ai-3d-kinetic-workflow-loop.webp'],
  },
  {
    number: '03',
    slug: 'ai-learning-skill-system',
    name: 'AI 项目协作工作台',
    tag: 'AI PROJECT / CLIENT WORKBENCH',
    description: '输入目标即可创建清晰的项目路径，将学习准备、执行任务、复盘沉淀与成果归档整合在同一工作台中，客户端可直接查看进度并继续任务。',
    metrics: ['目标创建项目', '任务进度可视化', '成果自动归档'],
    images: [aiProjectCollaborationCover],
  },
  {
    number: '04',
    slug: 'xiaohei-ai-video',
    name: '小黑 AI 视频生成工作台',
    tag: 'AI PROJECT / VIDEO WORKBENCH',
    description: '输入文案即可自动完成内容理解、画面组织与视频生成；客户端可查看生成进度、预览成片并下载，无需接触底层工具。',
    metrics: ['文案生成视频', '过程可视化', '预览与下载'],
    images: [xiaoheiVideoWorkbenchCover],
  },
  {
    number: '05',
    slug: 'msn-video-watermark-removal',
    name: 'AI 视频去水印工作台',
    tag: 'AI PROJECT / CLIENT TOOL',
    description: '上传视频后自动识别水印出现的位置与时刻，客户端可拖动查看处理前后效果、检查时间轴并直接导出无水印视频。',
    metrics: ['自动识别水印', '前后效果对比', '无水印视频导出'],
    images: [watermarkRemovalWorkbenchCover],
  },
  {
    number: '06',
    slug: 'v21-video-editing',
    name: '口播剪辑与包装工作流 V21',
    tag: 'AI PROJECT / VIDEO EDITING',
    description: '围绕口播视频生产，整合粗剪审核、字幕、文字包装与封面编辑，并将工作流整理为可迁移的便携环境。',
    metrics: ['粗剪审核', '文字与封面同步', '便携环境与快速预览'],
    images: ['/assets/core-projects/v21-video-editing-cover.png', '/assets/core-projects/v21-video-editing-loading.png'],
  },
  {
    number: '07',
    slug: 'local-ai-mobile',
    name: '手机端本地 AI 图像服务',
    tag: 'AI PROJECT / MOBILE WORKFLOW',
    description: '通过 Android 客户端提交图片、图集链接与编辑要求，由电脑端调用本地 ComfyUI 工作流，处理后将结果返回手机。',
    metrics: ['移动端提交', 'ComfyUI 整合', '图集链路处理'],
    images: ['/assets/core-projects/local-ai-mobile-schematic.png'],
  },
] as const;

export const applicationProjects = [
  {
    number: '14', slug: 'msn-ai-radar', name: 'MSN AI 点赞雷达',
    tag: 'AI PROJECT / CONTENT RADAR',
    description: '新版雷达工作台将点赞内容的分类浏览、多维分析、关键词检索与智能对话集中呈现，把零散收藏转化为系统化的创作灵感与研究线索。',
    metrics: ['分类筛选与检索', '智能对话与线索挖掘', '多维价值深度分析'],
    images: ['/assets/project-demos/radar/overview.jpg'],
  },
  {
    number: '13',
    slug: 'msn-task-workspace',
    name: 'MSN 任务工作台',
    tag: 'APPLICATION / AI TASK WORKSPACE',
    description: '以统一的桌面工作台组织任务、计划与专注，结合任务拆解、真实暂缓与恢复，以及嵌入式 AI 助手，让当前要推进的工作更清楚。',
    metrics: ['桌面交互定制', '任务暂缓与恢复', 'AI 任务工具集成'],
    images: ['/assets/core-projects/msn-task-workspace/home.jpg'],
  },
  {
    number: '12',
    slug: 'msn-content-publishing',
    name: 'MSN AI 内容生产与发布工作台',
    tag: 'AI CONTENT / WORKFLOW & PUBLISHING',
    description: '将数字人口播、知识动画、成片核对与双账号发布组织为可复用流程，以实际成片、横竖封面和发布回执展示从创意到发布的交付能力。',
    metrics: ['视觉创作与包装', '双账号真实发布', '人工审片与反馈复盘'],
    images: ['/assets/core-projects/msn-content-publishing-case.png'],
  },
  {
    number: '11',
    slug: 'digital-human-ai-review',
    name: '自动化剪辑与内容生产全流程',
    tag: 'CONTENT SYSTEM / PRODUCTION PIPELINE',
    description: '从选题脚本与素材产出出发，串联配音、数字人口播、文稿驱动剪辑、字幕图文包装及横竖封面，整理完整发布包并衔接发布回执。以已发布视频展示整套流程的实际成果。',
    metrics: ['配音与数字人口播', '智能剪辑与图文包装', '封面发布包与回执'],
    images: ['/assets/portfolio-covers/ai/ai-digital-human-review.webp'],
  },
  {
    number: '08',
    slug: 'super-msn-ledger',
    name: '超级 MSN Android 记账应用',
    tag: 'APPLICATION / ANDROID',
    description: '围绕日常记账构建 Android 应用，覆盖本地账本、账单导入、统计与支付识别草稿，并接入电脑端账本同步服务。',
    metrics: ['本地账本', '支付识别草稿', '持久同步队列'],
    images: ['/assets/core-projects/super-msn-ledger-mockup.png'],
  },
  {
    number: '09',
    slug: 'msn-study',
    name: 'MSN 本科成考学习系统',
    tag: 'APPLICATION / WEB & MOBILE',
    description: '将政治、英语和高数资料组织为完整学习工作台：题库练习与模拟、草稿续做、错题和计划进度、原卷参考、英语原文同页对照，以及支持图片问答、联网讲解和确认式题库维护的 AI 导师；电脑与手机共用学习入口。',
    metrics: ['练习模拟与断点续做', '原卷与英语原文对照', 'AI 导师与学习计划'],
    images: ['/assets/core-projects/msn-study-mockup.png'],
  },
  {
    number: '10',
    slug: 'finance-motion',
    name: '财经口播可编辑图解包装',
    tag: 'CONTENT CASE / EDITABLE MOTION',
    description: '将财经口播中的量价与经济概念转译为章节、动态图解、关键词与逐句素材安排，保留后续人工修改空间。',
    metrics: ['动态图解包装', '透明关键词', '可编辑时间线'],
    images: ['/assets/core-projects/finance-motion-diagram.png'],
  },
] as const;

// Detail pages keep their established import while the homepage stack binds
// explicitly to aiImageWorks.
export const coreProjects = aiImageWorks;

export const misteaImages = [
  { src: mistea01, series: 'MISTEA' },
  { src: mistea02, series: 'MISTEA' },
  { src: mistea03, series: 'MISTEA' },
  { src: mistea04, series: 'MISTEA' },
  { src: mistea05, series: 'MISTEA' },
  { src: mistea06, series: 'MISTEA' },
] as const;

export const robotVacuumImages = [
  { src: robot01, series: 'ROBOT VACUUM' },
  { src: robot02, series: 'ROBOT VACUUM' },
  { src: robot03, series: 'ROBOT VACUUM' },
  { src: robot04, series: 'ROBOT VACUUM' },
  { src: robot05, series: 'ROBOT VACUUM' },
  { src: robot06, series: 'ROBOT VACUUM' },
] as const;

export const humanCcdImages = [
  { src: human01, series: 'HUMAN / CCD' },
  { src: human02, series: 'HUMAN / CCD' },
  { src: human03, series: 'HUMAN / CCD' },
  { src: human04, series: 'HUMAN / CCD' },
  { src: human05, series: 'HUMAN / CCD' },
  { src: human06, series: 'HUMAN / CCD' },
] as const;

export const gptImages = [...misteaImages, ...robotVacuumImages, ...humanCcdImages] as const;

export type VideoItem = {
  slug: string;
  title: string;
  category: string;
  description: string;
  poster: string;
  coverUrl: string;
  orientation: 'wide' | 'vertical' | 'square';
  width: number;
  height: number;
  duration: number;
  videoUrl: string;
  previewUrl: string;
  previewLabel: string;
};

const orientationLabel = {
  wide: '横屏',
  vertical: '竖屏',
  square: '方形',
} as const;

const formatPreviewDuration = (duration: number) => {
  const minutes = Math.floor(duration / 60);
  const seconds = Math.floor(duration % 60);
  return minutes > 0 ? `${minutes} 分 ${seconds} 秒` : `${seconds} 秒`;
};

const toVideoItem = (
  item: typeof shootingWorks[number] | typeof aiWorks[number] | typeof gradingWorks[number],
  category: string,
): VideoItem => ({
  ...item,
  category,
  poster: item.coverUrl,
  previewUrl: `/assets/portfolio-previews/${item.group}/${item.slug}.mp4`,
  previewLabel: `${orientationLabel[item.orientation]} / ${formatPreviewDuration(item.duration)}`,
});

const publicDeploymentHiddenSlugs = import.meta.env.VITE_PUBLIC_DEPLOYMENT === 'true'
  ? new Set(['shoot-interview-million'])
  : new Set<string>();
const deploymentReadyShootingWorks = shootingWorks.filter((item) => !publicDeploymentHiddenSlugs.has(item.slug));

const filmingPool: readonly VideoItem[] = [
  ...deploymentReadyShootingWorks.map((item) => toVideoItem(item, '实拍剪辑')),
  ...gradingWorks.map((item) => toVideoItem(item, '调色案例')),
];
const filmingEdgeSlugs = new Set(['shoot-interview-million', 'shoot-interview-xuyan']);
export const filmingWorks: readonly VideoItem[] = [
  ...filmingPool.filter((item) => item.slug === 'shoot-xingtu-chemical'),
  ...filmingPool.filter((item) => item.slug === 'shoot-interview-million'),
  ...filmingPool.filter((item) => !filmingEdgeSlugs.has(item.slug) && item.slug !== 'shoot-xingtu-chemical'),
  ...filmingPool.filter((item) => item.slug === 'shoot-interview-xuyan'),
];
export const aiVideoWorks: readonly VideoItem[] = aiWorks.map((item) => toVideoItem(item, 'AI 视频'));
export const videoItems: readonly VideoItem[] = [...filmingWorks, ...aiVideoWorks];

export const officialTools = gradingWorks.map((item, index) => ({
  ...item,
  code: `COLOR / ${String(index + 1).padStart(2, '0')}`,
  name: item.title,
  skills: ['色彩校准', item.orientation === 'vertical' ? '竖屏调色' : '横屏调色', '成片对照'],
  evidence: [formatMediaDuration(item.duration), `${item.width}×${item.height}`, 'WEB PREVIEW READY'],
  image: item.coverUrl,
}));

export const simpleTools = [
  {
    code: 'UTILITY / 01',
    name: '矢量化插画单样例验证',
    description: '单个真实 PNG 已输出为 70 条可编辑 SVG 路径；当前作为简单工具卡，仍待第二样例与跨项目复用。',
    skills: ['图像处理', 'SVG 路径', '单样例验证'],
    image: vectorInput,
  },
] as const;

export const capabilities = [
  { name: '业务理解与需求拆解', detail: '视频业务洞察 · 流程结构规划 · 人工审核门禁' },
  { name: 'AI 工具整合与工作流', detail: 'ComfyUI · 模型集成 · 提示词工程 · 批量模板' },
  { name: '本地环境部署与维护', detail: 'Python · 运行时依赖 · 跨设备服务 · 便携化交付' },
  { name: '前端原型与应用集成', detail: 'React · TypeScript · 移动端交互 · 客户端联调' },
  { name: '调试验证与交付沉淀', detail: '异常诊断 · 真实测试 · 使用说明 · 证据归档' },
] as const;
